module.exports = __webpack_public_path__ + "assets/6d3bffbed8112ed876525139d39b6fa4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level5_WinKP35V1_23.mp3
 ** module id = 361
 ** module chunks = 0
 **/